<template>
	<div id="toppage">

		<div id="claims">
			<div class="container">

				<div class="row align-items-center">
					<div class="col-lg-1 col-2" id="col-logo">

						<a href="javascript:;" @click.prevent="$router.push({ name: 'Dashboard' })" rel="home" id="logo" class="text-center">
							<b-img src="img/layout/logo.png"/>
						</a>

					</div>
					<div class="col">
						<div class="official">
							{{ $t('gen.website') }}
							<strong>AS Roma</strong>
						</div>
					</div>
					<div class="col-lg-8 col-2 text-lg-right">
						<ul>
							<li>
								<b-dropdown size="sm" class="language-button" toggle-class="font-weight-bold" variant="light" :text="$i18n.locale.toUpperCase()">
									<b-dropdown-item v-if="$i18n.locale != 'it'" @click.prevent="$i18n.locale = 'it'">IT</b-dropdown-item>
									<b-dropdown-item v-if="$i18n.locale != 'en'" @click.prevent="$i18n.locale = 'en'">EN</b-dropdown-item>
								</b-dropdown>
							</li>
							<li class="d-none d-lg-inline-block">

								<div class="socials">
									<a href="https://www.facebook.com/officialasroma" title="Facebook" class="pl-2" target="_blank">
										<font-awesome-icon :icon="['fab', 'facebook-f']" />
									</a>
									<a href="https://twitter.com/OfficialASRoma" title="Twitter" class="pl-2" target="_blank">
										<font-awesome-icon :icon="['fab', 'twitter']" />
									</a>
									<a href="https://www.instagram.com/officialasroma/" title="Instagram" class="pl-2" target="_blank">
										<font-awesome-icon :icon="['fab', 'instagram']" />
									</a>
									<a href="https://www.youtube.com/asroma" title="YouTube" class="pl-2" target="_blank">
										<font-awesome-icon :icon="['fab', 'youtube']" />
									</a>
								</div>

							</li>
							<li class="d-lg-none">
								<div id="hamburger">
									<i class="fas fa-lg fa-bars"></i>
									<i class="fas fa-lg fa-times"></i>
								</div>
							</li>
						</ul>

					</div>
				</div>

			</div>
		</div>

		<header>
			<div class="container">

				<div class="row align-items-center" id="row-menu">
					<div class="col-lg-4 offset-lg-1 col-10 offset-2">

						<ul class="sponsors">
							<!-- <li>
								<b-img src="img/layout/logo-dbits.webp" />
								<!--<a @click.prevent=";" href="https://www.qatarairways.com/en-us/homepage.html" target="_blank"></a>- 	->
							</li> -->
							<!--<li>
								<b-img src="img/layout/logo-nb.webp" />
								<!--<a @click.prevent=";" href="https://www.qatarairways.com/en-us/homepage.html" target="_blank"></a>
							</li>-->
							<!--<li style="margin-left: -30px">
								<b-img src="img/layout/sponsor-hyundai.png" />
								< !- -<a @click.prevent=";" href="https://www.hyundai.it/" target="_blank"></a>- - >
							</li>-->
							<!-- <li>
								<b-img src="img/layout/sponsor-iqoniq.png" />
								<a @click.prevent=";" href="https://iqoniq.com/" target="_blank"></a>
							</li> -->
						</ul>

					</div>
					<div class="col-lg-7">

						<!-- <nav>
							<div class="menu-main-italiano-container">
								<ul id="menu-main-italiano" class="menu"><li id="menu-item-22" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-7 current_page_item menu-item-22"><a href="https://scuolacalcio.asroma.com/" aria-current="page">Home page</a></li>
									<li id="menu-item-678" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-678"><a href="https://scuolacalcio.asroma.com/news/">News</a></li>
									<li id="menu-item-675" class="menu-item menu-item-type-post_type_archive menu-item-object-facilities menu-item-675"><a href="https://scuolacalcio.asroma.com/facilities/">Strutture</a></li>
									<li id="menu-item-21" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-21"><a href="https://scuolacalcio.asroma.com/faq/">FAQ</a></li>
									<li id="menu-item-18" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-18"><a href="https://scuolacalcio.asroma.com/contatti/">Contatti</a></li>
								</ul>
							</div>

							<div class="langs-mobile text-center text-uppercase">
								<ul class="list-inline">
									<li class="list-inline-item">
										<a href="https://scuolacalcio.asroma.com/?lang=en">en</a>
									</li>
									<li class="list-inline-item">
										<a href="https://scuolacalcio.asroma.com">it</a>
									</li>
								</ul>
							</div>
						</nav> -->

					</div>
				</div>

			</div>
		</header>

	</div>
</template>

<script>
export default {
	name: 'WebHeader',
	data() {
		return {
			data: null
		}
	}
};
</script>

<style  lang="scss">


$font-size-sm: .8rem;
// $primary:
// $chiaro: ;
$scuro: #7e1327;
$giallo: #f7b717;
// $footer: #272727;
// $heading: #19181b;
//
// $line-height-base: 1.6;
// $body-color: #6f6f6e;
// $text-muted: #868686;
$primary: #981b2f;



#toppage{

	/*.language-button {

		z-index:9999;
		position: absolute;
		right: 2em;

		@media (min-width: 992px){

			backround-color: black !important;
			position: initial;
			margin-top: 0;
			margin-right: 0;
			
			.btn-light {
				font-size: 0.8rem !important;
			}

			.dropdown-item {
				font-size: 0.8rem !important;
			}


		}


		ul {
			margin: 0 !important;
			padding: 0 !important;
			min-width: 2.5rem;
		}

		.dropdown-item {
			margin: 0 !important;
			padding: 0.4em !important;
			color: black !important;
		}

	}*/

	/*position: sticky;*/
	top: 0;
	left: 0;
	z-index: 999;

	#claims, header{
		a{
			color: white;
		}
	}

	#claims{
		color: white;
		font-size: $font-size-sm;
		background: $primary;

		@media (min-width: 992px){
			background: $scuro;
		}

		.row{
			height: 32px;
		}

		ul{
			list-style: none;
			padding: 0;
			margin: 0;
			margin: 0;

			& > li{
				display: inline;

				&:not(:last-child){
					padding-left: .6rem;
				}
			}
		}

		strong{
			@media (min-width: 992px){
				font-weight: 600;
			}
		}

		#hamburger{
			font-size: 1.1rem;
			padding-top: 6px;
			padding-left: 10px;
			padding-right: 10px;

			.fa-times{
				display: none;
			}

			.fa-bars{
				display: inline-block;
			}

			&.active{
				.fa-bars{
					display: none;
				}
				.fa-times{
					display: inline-block;
				}
			}
		}

		#col-logo{
			@media (min-width: 992px){
				position: relative;
			}

			#logo{
				position: absolute;
				/*z-index: 999;*/
				z-index:1021;
				right: 0;
				top: -6px;
				width: 100%;
				height: 62px;

				@media (min-width: 992px){
					right: 0;
					top: -10px;
					max-width: 90px;
					height: 96px;
				}


				img{
					max-width: 100%;
					max-height: 100%;
					width: auto;
					height: auto;
				}
				@media (max-width:767px) {
					top:-10px;
					height:52px;
				}
			}
		}

		.official{
			@media (min-width: 992px){
				font-weight: 700;

				strong{
					font-weight: 900;
				}
			}
		}

		.socials{
			a{
				&:hover{
					text-decoration: none;
				}

				img{
					height: 18px;
				}
			}
		}

		#langs{
			text-transform: uppercase;

			@media (min-width: 992px){
				padding: 0 2rem;
			}

			$dx: 40px;

			.langs-content{
				position: relative;
				width: $dx;

				.langs-current{
					cursor: pointer;
				}

				ul.langs-list{
					background: white;
					border-radius: 3px;
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height: auto;
					z-index: 9;

					display: none;

					li{
						display: block;
						width: $dx;
						height: $dx;

						a{
							display: block;
							color: black;
							line-height: $dx;
							text-align: center;

							&:hover{
								text-decoration: none;
								font-weight: bold;
							}
						}
					}

					&.active{
						display: block;
					}
				}
			}
		}
	}

	header{
		background: $primary;
		color: white;
		border-bottom: 1px solid $giallo;

		$headerheight: 56px;

		#row-menu{
			@media (min-width: 992px){
				height: $headerheight;
			}
		}

		.sponsors{
			list-style: none;
			margin: 0;
			padding: 0;

			> li{
				display: inline-block;

				&:not(:last-child){
					padding-right: 8px;
				}

				img{
					display: block;
						height: 30px;
						object-fit: contain;
						object-position: center left;
						width: 60px;

						@media (min-width: 992px){
							width: 80px;
						}
					}
			}
		}

		nav{
			text-align: right;
			position: relative;
			font-size: $font-size-sm;
			font-weight: bold;

			.menu{
				list-style: none;
				background: $primary;
				text-align: center;
				display: none;
				padding: 2rem 0;
				margin: 0;
				font-size: $font-size-sm;

				&.active{
					display: block;
				}

				> li{
					> a{
						display: block;
						padding: 1rem;
					}

					&.signup{
						a{
							text-transform: uppercase;
							background: $scuro;
						}
					}
				}

				@media (min-width: 992px){
					display: inline-block !important;
					padding: 0;
					text-align: right;

					> li{
						display: inline-block;

						> a{
							padding: 0 1rem;
						}
					}

					a{
						line-height: 40px;
						border-bottom: 2px solid $primary;

						&:hover{
							text-decoration: none;
							border-bottom: 2px solid $giallo;
						}
					}
				}
			}
		}

		.langs-mobile{
			display: none;

			@media (min-width: 992px){
				visibility: hidden;
			}

			&.active{
				display: block;
			}
		}
	}
}
</style>
